import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class NetworkDiagnosticsService {
  private initialized = false;
  private counts = new Map<string, number>();
  private observer?: PerformanceObserver;

  init(): void {
    if (environment.production || this.initialized || typeof window === 'undefined') {
      return;
    }

    this.initialized = true;
    this.observeCompletedResources();
  }

  private observeCompletedResources(): void {
    if (typeof PerformanceObserver === 'undefined') return;

    this.observer = new PerformanceObserver(list => {
      list.getEntries().forEach(entry => {
        const resource = entry as PerformanceResourceTiming;
        const count = (this.counts.get(resource.name) || 0) + 1;
        this.counts.set(resource.name, count);

        const transferred = resource.transferSize || 0;
        console.debug('[network]', {
          url: resource.name,
          count,
          transferredBytes: transferred,
          decodedBytes: resource.decodedBodySize || 0,
          durationMs: Math.round(resource.duration),
          initiator: resource.initiatorType || 'unknown',
          cached: transferred === 0 && resource.decodedBodySize > 0,
        });

        if (count > 1 && transferred > 0) {
          console.warn(`[network] Duplicate transfer #${count}: ${resource.name}`);
        }

        if (resource.duration >= 10_000) {
          console.warn(
            `[network] Request took ${Math.round(resource.duration)}ms: ${resource.name}`
          );
        }
      });
    });

    this.observer.observe({ entryTypes: ['resource'] });
  }
}
